import { drawCable } from '@/utils/drawBundle';
import { drawWireTopology } from '@/utils/wireTurns';
import { Signal } from '@/models/data/Signal';
import { TileType } from '@/models/TileTypes';
import { TileDefinition, TileGraphicsDefinition } from '@/models/tiles/TileDefinition';
import { Side, TileSideIOType } from '@/schemas/tiles';
import { colors } from '@/styles';
import { defaultTileGraphics } from '@/models/tiles/DefaultTileGraphics';
import { wireBuildAndConnect } from '@/models/logic/utils';

export class WireTile implements TileDefinition {
  type = TileType.Wire;
  name = 'Wire';
  canRotate = false;

  createDefaultState = () => null;
  buildAndConnectNodes = wireBuildAndConnect;

  ioSides = {
    [Side.TOP]: { type: TileSideIOType.INPUT_OUTPUT, forceConnection: false },
    [Side.RIGHT]: { type: TileSideIOType.INPUT_OUTPUT, forceConnection: false },
    [Side.BOTTOM]: { type: TileSideIOType.INPUT_OUTPUT, forceConnection: false },
    [Side.LEFT]: { type: TileSideIOType.INPUT_OUTPUT, forceConnection: false },
  };

  graphics = wireTileGraphics;
}

export const wireTileGraphics: TileGraphicsDefinition = {
  type: TileType.Wire,
  draw: (graphics, { meta, connections }) => {
    defaultTileGraphics(graphics);

    if (meta.cable) {
      drawCable(graphics, connections);
      return;
    }
    const isHigh = Object.values(meta.inputs).some((signal) => signal === Signal.HIGH);
    drawWireTopology(
      graphics,
      connections,
      isHigh ? colors.signalColor : colors.noSignalColor,
    );
  },
};
